export default class SizeType {
  fromPrice = 0;
  availableAmount = 0;
  width = 0;
  height = 0;
  length = 0;
  sizeInSquareMeters = 0;
  levelAmount = 0;
  levelPrice = [];

  constructor(
    id,
    title,
    description,
    sizeInSquareMeters,
    sizeTypes,
    images,
    formSize,
    isIndoor
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.sizeInSquareMeters = sizeInSquareMeters;
    this.sizeTypes = sizeTypes;
    this.images = images;
    this.formSize = formSize ?? null;
    // Fallback indoor/outdoor status, configured per size type. Only used when
    // no available room of this size type reports its own status (e.g. sold out).
    this.isIndoor = typeof isIndoor === 'boolean' ? isIndoor : null;
  }
}
